import React, { useState, useEffect } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import DailyCollectionReportTable from "../../../components/operator/daily-collection-report-table";

function DailyCollectionReport() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [fromDate, setFromDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <SideBar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5>Daily Collection Report</h5>
            <Form>
              <Row className="align-item-end g-3 mb-3">
                <Col md={4}>
                  <Form.Group controlId="formDate">
                    <Form.Label>
                      From Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="fromDate"
                      value={fromDate}
                      onChange={(e) => {
                        setFromDate(e.target.value);
                        setReport(false);
                        setButtonClicked(false);
                        setLoader(false);
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="formDate">
                    <Form.Label>
                      To Date<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="toDate"
                      value={toDate}
                      onChange={(e) => {
                        setToDate(e.target.value);
                        setReport(false);
                        setButtonClicked(false);
                        setLoader(false);
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button
                variant="primary"
                type="button"
                disabled={buttonClicked}
                onClick={() => {
                  if (!report) {
                    setButtonClicked(true);
                    setLoader(true);
                    setReport(true);
                  }
                }}
              >
                SEARCH
              </Button>
            </Form>
          </div>
          {report && (
            <div className="container bg-white p-4 rounded shadow-sm mt-4">
              <h5 className="mb-3">
                Report for {fromDate} to {toDate}
              </h5>
              <DailyCollectionReportTable
                fromDate={fromDate}
                toDate={toDate}
                setLoader={setLoader}
                setButtonClicked={setButtonClicked}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DailyCollectionReport;
